import React from 'react'
import {isMobile, useMobileOrientation} from "react-device-detect";
import {Slide} from "react-slideshow-image";

const slideImages = [
    {
        url: '/images/popups/arredi/1-arredi.jpg',
    },
    {
        url: '/images/popups/arredi/3-arredi.jpg',
    },
    {
        url: '/images/popups/arredi/4-arredi.jpg',
    },
    {
        url: '/images/popups/arredi/5-arredi.jpg',
    },
    {
        url: '/images/popups/arredi/6-arredi.jpg',
    }
];

const Slideshow = () => {
    const properties = {
        duration: 4000,
        autoplay: true,
        transitionDuration: 1000,
        arrows: true,
        infinite: true,
        easing: "ease",
        prevArrow: <button style={{marginLeft: 20}} ><img alt="prev-slide" src="/images/assets/slider-arrow-prev.png" className="h-[45px]] w-[45px] cursor-pointer" /></button>,
        nextArrow: <button style={{marginRight: 20}}><img alt="prev-slide" src="/images/assets/slider-arrow-next.png" className="h-[45px]] w-[45px] cursor-pointer" /></button>,
        cssClass: ''
    };
    return (
        <div className="slide-container h-full">
            <Slide {...properties}>
                {slideImages.map((slideImage, index) => (
                    <>
                        {index === 1 && <div className="each-slide h-full" key={index}>
                            <video autoPlay muted loop id="video" className="h-full">
                                <source src="/images/popups/arredi/2 allestimento pupa 1.mp4" type="video/mp4"/>
                            </video>
                        </div>}
                        {index !== 1 && <div className="each-slide h-full" key={index}>
                            <div className="bg-cover bg-no-repeat h-full w-full" style={{backgroundImage: `url(${slideImage.url})`}}>
                            </div>
                        </div>}
                    </>

                ))}
            </Slide>
        </div>
    )
}

export default function ArrediHotspot({setHotspot}) {
    const { isLandscape } = useMobileOrientation()
    return (
        <div className="bg-[#bd7762]/80 h-screen w-screen absolute top-0 left-0 z-40 flex flex-col items-center justify-center">
            <div className={`overflow-hidden bg-[#f2efef] flex ${isMobile && !isLandscape ? "flex-col" : isMobile && isLandscape} ${isMobile ? "w-[90vw] h-[90vh]" : "flex-row w-[80vw] h-[80vh]"}`}>
                <div className={`w-full overflow-hidden ${isMobile && !isLandscape ? "h-[400px]" :  "h-full"} ${isMobile && isLandscape ? "min-w-[300px]" : ""}`}>
                    <Slideshow />
                </div>
                <div className={`overflow-hidden flex flex-col ${isMobile ? "h-full" : "w-[55%] min-w-[55%]"}`}>
                    <div className={`p-[30px] pb-[10px] ${isMobile && !isLandscape ? "absolute top-[30px] right-[10px] p-[20px]" : isMobile && isLandscape ? "absolute top-[10px] right-[30px] p-[20px]" : "self-end"}`}>
                        <img alt="close-icon" src="/images/assets/close-menu-icon.svg" className="h-[45px]] w-[45px] cursor-pointer" onClick={() => setHotspot(0)}/>
                    </div>
                    <div className={`overflow-hidden ${isMobile ? "p-[30px] pt-[40px]" : "p-[60px] pt-[0]"}`} style={{overflowY: 'auto'}}>
                        <h2 className="font-primary text-[45px] leading-[54px] font-semibold pb-10">Arredi</h2>
                        <p className="font-primary text-[13px] leading-[21px] pb-[30px]">Materiali di pregio come il seminato veneziano, il marmo afgano nero, le finiture in rame, ed il design ricercato degli arredi fissi contraddistinguono i raffinati interni.</p>
                        <p className="font-primary text-[13px] leading-[21px] pb-[30px]">Oltre venti metri di nicchie versatili utilizzabili per ogni tipo di allestimento, poltrone e sedie firmate Pedrali, tavoli e tavolini multifunzione e aggregabili.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
